import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { ConfirmationService, SelectItem } from 'primeng/api';
import { Table } from 'primeng/table';
import {forkJoin} from 'rxjs';
import {GarantiasIdoneas} from '../../../_models/garantias-idoneas';
import {GarantiasIdoneasDestino} from '../../../_models/garantias-idoneas-destino';
import {ListaItem} from '../../../_models/lista-item';
import {GarantiaIdoneasDestinosService} from '../../../_services/garantia-idoneas-destinos.service';
import {ListaService} from '../../../_services/lista.service';
import {NavService} from '../../../_services/_nav.service';
import {AutenticacionService} from '../../../_services/autenticacion.service';
import {SegmentoNivelEndeudamiento} from '../../../_models/segmento-nivel-endeudamiento';
import {GarantiasIdoneasProducto} from '../../../_models/garantias-idoneas-producto';

@Component( {
  selector: 'app-garantia-idoneas-destinos',
  templateUrl: 'garantia-idoneas-destinos.component.html'
} )

export class GarantiaIdoneasDestinosComponent implements OnInit {

  formulario: FormGroup;
  /** items */
  @Input() garantia: GarantiasIdoneas;
  destino: GarantiasIdoneasDestino;

  /** Listas */
  listaDestinos: ListaItem[] = [];
  listGarantiasIdoneasDestino: GarantiasIdoneasDestino[] = [];
  lisDestino: SelectItem[] = [];


  columnas: any[] = [];
  carInformacionInicial = true;
  submitted = false;
  guardando = false;
  carTabla = true;
  indicadorPlan = false;
  @ViewChild('dt') tabla: Table;

  constructor(
    private conServicio: ConfirmationService,
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private lisServicio: ListaService,
    private navServicio: NavService,
    private router: Router,
    private autServicio: AutenticacionService,
    private garantiasIdoneasDestinoServices: GarantiaIdoneasDestinosService,
    private confirmacionServicio: ConfirmationService,
  ) {
  }

  ngOnInit() {

    if ( this.garantia && (this.garantia.idGarantiaIdonea !== '' && this.garantia.idGarantiaIdonea !== null && this.garantia.idGarantiaIdonea !== undefined) ) {
      /** Se carga garantias Servicios */
      forkJoin(
        this.garantiasIdoneasDestinoServices.listadoPorDestinos( this.garantia.idGarantiaIdonea ),
        this.lisServicio.getMasterDetails( 'ListasDestinosProductos' )
      ).subscribe( ( [ garantiaDestinos, lisDestinoC ] ) => {
        this.listGarantiasIdoneasDestino = garantiaDestinos;
        this.listaDestinos = lisDestinoC;
        this.cargarInformacionInicial();
      } );
    }
  }

  get getGarantiasIdoneasDestino() {
    return this.listGarantiasIdoneasDestino.filter( s => s.indicadorHabilitado );
    this.carTabla = false;
  }


  cargarInformacionInicial() {

    this.carTabla = false;
    this.columnas = [
      { field: 'codigoDestinoProducto', header: this.navServicio.buscarMensaje( 'GARANTIASIDONEAS.LBL_ID' ), sort: true },
      { field: 'destinoProducto', header: this.navServicio.buscarMensaje( 'GARANTIASIDONEAS.LBL_DESTINOS' ), sort: true },
      { field: 'det', header: this.navServicio.buscarMensaje( 'LBL_ACCIONES' ), sort: false }
    ];
    this.formulario = this.fb.group( {
      idGarantiaIdonea: [ this.destino ? this.destino.idGarantiaIdonea : null ],
      idDestinoProducto: [ [], [ Validators.required ] ],
      indicadorHabilitado: [ true ]
    } );
    this.carDropdown();

    this.indicadorPlan = false;
    this.carInformacionInicial = false;
  }

  get f() {
    return this.formulario.controls;
  }

  onSubmit() {
    this.submitted = true;
    if ( this.formulario.valid ) {
      this.guardando = true;
      const forData = this.formulario.value;
      const tempGarantiasDestino: GarantiasIdoneasDestino[] = [];
      forData.idDestinoProducto.forEach(destino => {
        let temp  = {} as GarantiasIdoneasDestino;
        temp.idGarantiaIdonea = this.garantia.idGarantiaIdonea;
        temp.idDestinoProducto = destino;
        temp.indicadorHabilitado = true;
        const a = this.listGarantiasIdoneasDestino.find( sp => sp.idDestinoProducto === destino );
        if ( a ) {
          temp.idGarantiaIdoneaDestinoProducto = a.idGarantiaIdoneaDestinoProducto;
        }
        tempGarantiasDestino.push(temp);
      });

      this.garantiasIdoneasDestinoServices.bulk( tempGarantiasDestino ).subscribe( res => {
         const tempSegmentoP: GarantiasIdoneasDestino[] = this.listGarantiasIdoneasDestino;
         this.listGarantiasIdoneasDestino = [];
         res.map(re => {
           re.codigoDestinoProducto = this.listaDestinos.find( p => p.idLista === re.idDestinoProducto ).codigo;
           re.destinoProducto = this.listaDestinos.find( p => p.idLista === re.idDestinoProducto ).nombre;
           tempSegmentoP.map( t => {
              if ( t.idGarantiaIdoneaDestinoProducto === re.idGarantiaIdoneaDestinoProducto ) {
                t.indicadorHabilitado = true;
              }
           } );
           if(!tempSegmentoP.find(di=> di.idGarantiaIdoneaDestinoProducto ===  re.idGarantiaIdoneaDestinoProducto)){
             tempSegmentoP.push(re);
           }
         });
         this.listGarantiasIdoneasDestino = tempSegmentoP;
         this.carDropdown();
         this.formulario.reset();
         this.submitted = false;
         this.guardando = false;
      } );
    }
  }

  disable( row: GarantiasIdoneasDestino ): void {
    this.confirmacionServicio.confirm( {
      message: '¿Está seguro que desea inactivar este registro?',
      header: 'Garantías idóneas Destinos',
      icon: 'fa fa-question-circle',
      key: 'garantia-idoneas-destino',
      accept: () => {
        row.indicadorHabilitado = false;
        this.garantiasIdoneasDestinoServices.actualizar( row ).subscribe( res => {
          const temp: GarantiasIdoneasDestino[] = this.listGarantiasIdoneasDestino;
          this.listGarantiasIdoneasDestino = [];
          temp.map( t => {
            if ( t.idGarantiaIdoneaDestinoProducto === row.idGarantiaIdoneaDestinoProducto ) {
              t.indicadorHabilitado = false;
            }
          } );
          this.listGarantiasIdoneasDestino = temp;
          this.carDropdown();
        } );
      }
    } );
  }

  carDropdown(): void {
    this.lisDestino = [];
    this.listaDestinos.map(  s => {
      if ( !this.listGarantiasIdoneasDestino.find( ga => ga.indicadorHabilitado &&
        ga.idDestinoProducto === s.idLista) ) {
        this.lisDestino.push( { label: s.nombre, value: s.idLista } );
      }
    } );
  }




  }
